import React from 'react';
import { connect } from 'react-redux';
import * as routes from 'app/routes';
import Back from 'common/Back';
import SelectPlan from 'insurance/insurancePlans/SelectPlan';
import styles from './InsurancePlan.module.css';

const QuickInsurancePlan = ({ subId, sku, next }) => (
  <div>
    <Back to={routes.quickInsuranceDevice(subId)} />
    <h1 className={styles.header}>Confirm your Device Protection plan</h1>
    <SelectPlan subId={subId} sku={sku} next={next} />
  </div>
)

export default connect(
  null,
  { next: routes.quickInsuranceConfirm }
)(QuickInsurancePlan);
